<template>
  <vx-card class="editor-mid-card">
    <!-- <vue-perfect-scrollbar class="scroll-area" :settings="settings"> -->
    <div class="mb-base">
      <div class="flex justify-between flex-wrap">
        <vs-row vs-w="6">
          <h3 class="float-left mr-4">{{ $t('editor.projects.title') || 'My Projects' }}</h3>
          <vx-tooltip v-if="saveInProgress" text="Saving to cloud...">
            <feather-icon icon="CloudIcon" class="save-in-progress-status-icon" svgClasses="text-success" /></vx-tooltip>
          <vx-tooltip v-else :text="$t('editor.projects.saveToCloud')"><feather-icon icon="CloudIcon"
              class="save-in-progress-status-icon" /></vx-tooltip>
        </vs-row>
        <div>
          <!-- <options :previousMove="{ name: 'editor-personality' }" :nextMove="{ name: 'editor-projects' }" /> -->

          <!-- Change from whatever it is currently, to point to Offers -->
            <options :previousMove="{ name: 'editor-educational-qualifications' }" :nextMove="{ name: 'editor-offers' }" />
        </div>
      </div>
      <!-- <p v-if="!isUserLoggedIn" class="text-danger">
          You are not authenticated. Please login to save your data.
        </p>
        <p v-else-if="internetConnectionStatus">
          Internet Connection Active. Keep editing and your data gets auto-saved.
        </p>
        <p v-else class="text-danger">
          No Internet Connection. Please connect to Internet to save your data.
        </p> -->
    </div>
    <div class="mb-2">
      <div>
        <div v-if="projects.length" class="projects-block">
          <VuePerfectScrollbar class="scroll-area--list" :settings="settings">
            <draggable v-model="projects" :disabled="draggableDisabled" class="list-groupp" ghost-class="ghostt"
              :move="checkMove" @start="dragging = true" @change="updateOrder">
              <vs-row class="mb-4" icon-pack="feather" icon="icon-move" :key="indextr" v-for="(tr, indextr) in projects">
                <vs-col vs-w="1">
                  <feather-icon icon="MoveIcon" svgClasses="h-4 w-4" class="mr-3 cursor-move" />
                </vs-col>
                <vs-col v-if="tr.projectPictureUrl" class="text-limited" vs-w="3">
                  <img :src="
                                            constants.s3Bucket +
                                            '/editor/project-pictures/' +
                                            tr.projectPictureUrl
                                          " class="w-1/2 project-img" />
                </vs-col>
                <vs-col v-else vs-w="3">{{ $t('editor.projects.editDataToViewHere') }}</vs-col>
                <vs-col class="text-limited" vs-w="3">
                  {{ tr.title }}
                </vs-col>
                <!-- <vs-td v-else>None</vs-td> -->
                <vs-col vs-w="3">
                  {{ tr.organization }}
                </vs-col>
                <!-- <vs-td v-else>None</vs-td> -->
                <!-- <vs-col vs-w="2">
                    {{ formatDate(tr.endDate) }}
                  </vs-col> -->
                <!-- <vs-td v-else>None</vs-td> -->
                <vs-col class="whitespace-no-wrap" vs-w="2">
                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current cursor-pointer"
                    @click.stop="editProject(tr)" />
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer"
                    class="ml-2" @click.stop="deleteProject(tr._id)" />
                </vs-col>
              </vs-row>
            </draggable>
          </VuePerfectScrollbar>
        </div>
        <div v-else class="items-center">{{ $t('editor.utils.noDataAvailable') }}</div>
      </div>
    </div>

    <div v-if="isUserLoggedIn" class="flex justify-between flex-wrap mb-base">
      <p class="add-experience-btn text-primary font-bold" @click="addProject()">
        <u>+ {{ $t('editor.projects.addProject') }}</u>
      </p>
    </div>
    <p v-else>

      <span v-if="organizationSlug === 'default'">
        <router-link :to="{ name: 'editor-about' }">{{ $t('editor.projects.login') }}</router-link> {{
                $t('editor.projects.toAddYourProjects') }}
      </span>
      <span v-else>
        <router-link :to="{ name: 'editor-about' }">{{ $t('editor.projects.login') }}</router-link> {{
                $t('editor.projects.toAddYourProjects') }}
      </span>

    </p>

    <div v-if="addForm" class="main-form">
      <div class="vx-row">
        <div class="vx-col mb-base w-full md:w-1/2">
          <vs-row class="mb-base">
            <label>{{ $t('editor.projects.projectTitle') }}<span class="required-field">*</span></label>
            <vs-input class="w-full dark-input-field" name="Title" maxlength="250" data-vv-validate-on="blur"
              v-validate="'required'" :disabled="disableInputField" v-model="localData.title"
              @blur="saveField('savePRTitle', 'Title')" />
            <span class="text-danger text-sm">{{
                          errors.first("Title")
                          }}</span>
          </vs-row>
          <vs-row>
            <label>{{ $t('editor.projects.organization') }}</label>
            <v-select class="w-full" name="Organization" maxlength="250" :disabled="disableInputField"
              v-model="localData.organization" :options="orgOptions" @input="saveField('savePROrganization')" />
          </vs-row>
        </div>
        <div class="vx-col mb-base w-full md:w-1/2">
          <input type="file" class="hidden" name="Project Picture" ref="update_project_picture"
            @change="updateProjectPicture" accept="image/*" :disabled="disableInputField" />
          <div v-if="localData.projectPictureUrl" class="project-picture project-picture--set" :style="{
                            background:
                              'url(' +
                              constants.s3Bucket +
                              '/editor/project-pictures/' +
                              localData.projectPictureUrl +
                              ')',
                          }">
            <div class="project-picture--picture project-picture--picture-set items-center vs-con-loading__container"
              id="upload-project-picture">
              <img src="@/assets/images/icons/editor-icons/video-pitch-icon.svg"
                @click="$refs.update_project_picture.click()" />
              <p>{{ $t('editor.projects.updateProjectPicture') }}</p>
              <p>{{ $t('editor.projects.upto3Mb') }}</p>
            </div>
          </div>
          <div v-else class="project-picture">
            <div class="project-picture--picture items-center vs-con-loading__container" id="upload-project-picture">
              <img src="@/assets/images/icons/editor-icons/video-pitch-icon.svg"
                @click="$refs.update_project_picture.click()" />
              <p>{{ $t('editor.projects.addProjectPicture') }}</p>
              <p>{{ $t('editor.projects.upto3Mb') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <label>{{ $t('editor.projects.description') }}</label>
          <vs-textarea class="w-full" name="Description" maxlength="2600" :disabled="disableInputField"
            v-model="localData.description" @blur="saveField('savePRDescription')" />
        </div>
      </div>
    </div>
    <!-- </vue-perfect-scrollbar> -->
  </vx-card>
</template>

<script>
import vSelect from "vue-select";
import FeatherIcon from "../../components/FeatherIcon.vue";
import Options from "./components/Options.vue";
import constants from "@/constants";
import {
  saveInputFieldService,
  deleteDocumentService,
  updateImageService,
} from "@/services/editor/projects.service.js";
import DataList from "./components/DataList.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import _ from "lodash";
import draggable from "vuedraggable";

export default {
  components: {
    FeatherIcon,
    Options,
    DataList,
    VuePerfectScrollbar,
    draggable,
    vSelect,
  },
  name: "EditorProjects",
  data() {
    return {
      localData: {},
      addForm: false,
      selectedCHRow: {},
      constants,
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 40,
        wheelSpeed: 0.6,
      },
      draggableDisabled: false,
    };
  },
  computed: {
    otpSent() {
      return this.$store.state.auth.otpSent;
    },
    saveInProgress() {
      return this.$store.state.editor.saveInProgress;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    careerHistory() {
      return this.$store.state.editor.careerHistory;
    },
    projects: {
      get: function () {
        return this.$store.state.editor.projects;
      },
      set: function (newVal) {
        this.$store.commit("editor/SET_PROJECTS", newVal);
      },
    },
    orgOptions() {
      let oo = [];
      this.careerHistory.forEach((ch) => {
        oo.push(ch.company);
      });
      return oo;
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
    internetConnectionStatus() {
      return this.$store.state.users.internetConnectionStatus;
    },
    disableInputField() {
      return !this.isUserLoggedIn || !this.internetConnectionStatus;
    },
    scrollBarTag() {
      return "VuePerfectScrollbar";
    },
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
  },
  watch: {},
  methods: {
    updateOrder(e) {
      _.debounce(
        function (currentThis) {
          const newProject = currentThis.projects.map(function (ch, index) {
            return { _id: ch._id, oldSortId: ch.sortId, newSortId: index };
          });

          newProject.forEach((ch) => {
            currentThis.draggableDisabled = true;
            currentThis.$store
              .dispatch("editor/updateProjectsOrder", {
                _id: ch._id,
                sortId: ch.newSortId,
              })
              .then((res) => {
                currentThis.draggableDisabled = false;
              });
          });
        },
        800,
        { leading: false, trailing: true }
      )(this);
    },
    checkMove: function (e) {
      // window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    formatDate(date) {
      if (date) {
        return date.split("T")[0];
      }
    },
    addProject() {
      const sortId = this.projects.length + 1;
      this.$store
        .dispatch("editor/createProject", { userId: this.userId, sortId })
        .then((res) => {
          this.localData = res.data;
          this.addForm = true;
          this.$forceUpdate();

          this.$vs.notify({
            title: "New Project Created",
            text: "Start editing data and your data gets auto-saved.",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
            fixed: false,
          });
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Error creating a new Project",
            text: "",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            fixed: false,
          });

          throw err;
        });
    },
    editProject(data) {
      this.errors.clear();

      this.localData = JSON.parse(JSON.stringify(data));
      this.localData.startDate = this.formatDate(this.localData.startDate);
      this.localData.endDate = this.formatDate(this.localData.endDate);
      this.addForm = true;
    },
    deleteProject(id) {
      this.errors.clear();

      this.deletionProjectId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this Project entry?",
        acceptText: "Delete",
        accept: this.confirmDeleteProject,
      });
      this.addForm = false;
      this.localData = {};
    },
    confirmDeleteProject() {
      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        projectId: this.deletionProjectId,
        currentThis: this,
      };

      deleteDocumentService(payload);
    },
    async saveField(action, fieldName = null) {
      let fieldIsValid = false;

      //// console.log(this.localData);

      if (fieldName) {
        fieldIsValid = await this.$validator.validate(fieldName);

        if (!fieldIsValid) {
          return;
        }
      } else {
        fieldIsValid = true;
      }

      //// console.log(fieldIsValid);

      if (fieldName && !fieldIsValid) {
        return;
      }

      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        action,
        localData: this.localData,
        projectId: this.localData._id,
        currentThis: this,
      };

      //// console.log(this.localData, payload)

      saveInputFieldService(payload);
    },
    updateProjectPicture(input) {
      const payload = {
        imgInput: input,
        currentThis: this,
        userId: this.localData.userId,
        projectId: this.localData._id,
        maxSize: 3, // In MB
      };

      updateImageService(payload);
    },
  },
  created() {
    this.$store.dispatch("editor/toggleRightBar", true);
    this.$store.dispatch("editor/togglePreviewMode", false);
  },
};
</script>

<style scoped>
.scroll-area--list {
  position: relative;
  margin: auto;
  height: 100px;
  width: 100%;
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 615px;
  /*height: 1000px;*/
}

.projects-block {
  background: #f7f7f7;
  border-radius: 6px;
  padding: 10px 2px 10px 25px;
  overflow-x: auto;
}
.project-img{
  object-fit: cover;
  height: 5.75em;
}

.show-experience-on-map {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: #7c7c7c;

  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 12px 0px;
}

.currently-active {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  color: #7c7c7c;

  /* Inside Auto Layout */

  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 8px 0px;
}

.add-experience-btn {
  cursor: pointer;
}

.vs-con-textarea>>>.vs-textarea {
  height: 80px !important;
}

.project-picture {
  background: #ffffff;
  border: 1px dashed #f29200;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 5px;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.project-picture--picture {
  background: rgba(242, 147, 0, 0.1);
  border-radius: 12px;
  width: 100%;
  height: 100%;
  padding: 1.5rem;
}

.project-picture--picture p:nth-child(2) {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: #f29200;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 2px 4px;
}

.project-picture--picture p:nth-child(3) {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: rgba(242, 146, 0, 0.6);
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 0px 4px;
}

/* when project picture set */
.project-picture--set {
  background-size: cover !important;
  background-position: center center !important;
  border: none !important;
}

.project-picture--picture-set {
  background: none !important;
}

.project-picture--picture-set p:nth-child(2) {
  color: #ffffff !important;
}

.project-picture--picture-set p:nth-child(3) {
  color: #ffffff !important;
  /*rgba(242, 146, 0, 0.6)*/
}

.dark-input-field>>>.vs-con-input .vs-input--input {
  background: #edededab !important;
}

.vs-con-textarea>>>.vs-textarea {
  background: #edededab !important;
}
</style>